import { formatToCurrency } from '@betgames/bg-tools';
import { partnerSettingsStore } from '@bg-shared/business/PartnerSettings';
import { DASH_LONG } from '@bg-shared/constants/textSymbols';

export const currencyRangeFormat = (...amounts: (number | string)[]): string => {
    const { partnerSettings } = partnerSettingsStore;

    return partnerSettings.currency.template.replace(
        'X',
        amounts
            .map((amount) =>
                formatToCurrency(
                    amount,
                    partnerSettings.currency.precision,
                    'X',
                    partnerSettings.currency.code,
                ),
            )
            .join(DASH_LONG),
    );
};
